const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles(() => ({
    paper: {
        width: '97.5%',
        margin: '0 auto 20px',
    },
    cardButton: {
        width: '100%',
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // minWidth: 220,
        // margin: 5,
        minHeight: 120,
        position: 'relative',
        padding: 12,
        borderRadius: 8,
        transition: 'background-color 0.3s ease-in-out',
        margin: 0,
        '&:hover': {
            backgroundColor: '#e0e0e0',
        }
    },
    title: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    btnsContainer: {
        position: 'absolute',
        right: -12,
        top: -8
    },
    btns: {
        padding: '8px'
    },
    textFieldContainer: {
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'space-between'
    },
    textField: {
        width: '100%',
        fontSize: '14px',
        '& .MuiInputBase-root': {
            fontSize: '14px',
        }
    },
    subtitle: {
        marginTop: '12px',
        fontSize: 14,
    },
    numbers: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    infoContainer: {
        width: '100%'
    },
    updateBtn: {
        marginTop: '12px',
        width: '120px',
        height: '30px',
        fontSize: 14
    }
}))